import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconBack } from "../../icons/Icon";
import KitchenIndentDetails from "./KitchenIndentDetails";
import { useNavigate } from 'react-router-dom';
import { fetchMogs } from "../../services/kitchenIndentSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { format } from 'date-fns/esm';

const KitchenIndent = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
    const { params, previousPlan } = useSelector((state: any) => state.productionPlan);
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(fetchMogs({
      mogcode: "",
      searchtext: ""
    }));
  }, [])

  return (
    <div className="content-wrapper">
      <div className="flex align-items-center justify-content-between" style={{ marginBottom: "9px" }}>
        <h1 className="flex align-items-center mb-0">
          <button onClick={goBack} className="mr-10"><IconBack /></button>
          Kitchen Indent
        </h1>
        <div className="right flex align-items-center menu-period" style={{ marginRight: "4px" }}>
          <strong>Menu Date:</strong>
          <span>{params ? format(new Date(params?.menudate), 'dd-MMM-yyyy') : '--'}</span>
        </div>
      </div>
      <KitchenIndentDetails />
    </div>
  );
};

export default KitchenIndent;
